
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { UserRightsMixin } from '@/mixins/UserRights';
import { Moment } from 'moment';

@Component({
    name: 'ActiveStatus',
})
export default class ActiveStatus extends mixins<UserRightsMixin>(UserRightsMixin) {
    @Prop({ default: '' }) private manufactureDate!: { date: Moment | string; title: string };
    @Prop({ default: '' }) private deliveryDate!: { date: Moment | string; title: string };
}
